import React, { useState } from 'react';
import useApi from '../hooks/useApi';
import posthog from 'posthog-js';
import { notifyAdsEligibilityChanged } from '../utils/adsEligibility';

export default function SignUpPage({updateShowLogin,authenticated}) {
  const { request } = useApi();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirm_password:'',
    first_name: '',
    last_name: '',
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
    setMessage('');
  };

  const handleSubmit = async () => {
    setMessage('');
    if (formData.first_name === ''){
      setMessage("Please enter First Name!");
      return;
    }
    if (formData.last_name === ''){
      setMessage("Please enter Last Name!");
      return;
    }
    if (formData.email === ''){
      setMessage("Please enter Email!");
      return;
    }
    if (formData.password === ''){
      setMessage("Please enter Password!");
      return;
    }
    if (formData.password.length < 8){
      setMessage("Password must not be less than 8 characters!");
      return;
    }
    if (formData.confirm_password === ''){
      setMessage("Please enter Confirm Password!");
      return;
    }
    if (formData.password !== formData.confirm_password) {
      setMessage("Passwords do not match.");
      return;
    }  
    setLoading(true);
    posthog.capture('signup_attempt', {
      email_entered: formData.email !== '',
      password_length: formData.password.length,
      confirm_password_entered: formData.confirm_password !== '',
      name_provided: formData.first_name !== '' && formData.last_name !== '',
      password_match: formData.password === formData.confirm_password
    });
    try {
      const res = await request({
        method: 'post',
        url: 'api/v1/users/signup/',
        data: {
          email: formData.email,
          password: formData.password,
          first_name: formData.first_name,
          last_name: formData.last_name
        }
      });
      if (res?.access && res?.refresh) {
        localStorage.setItem('access_token', res.access);
        localStorage.setItem('refresh_token', res.refresh);
        localStorage.setItem('user_id', res.user_id);
        localStorage.setItem('name', res.first_name);
        localStorage.setItem('email', res.email);
        localStorage.setItem('is_premium', res.is_premium);
        notifyAdsEligibilityChanged();
        setMessage('Signup successful! You are now logged in.');
        posthog.capture('signup_success', {
          user_id: res.user_id,
          name: res.first_name,
          email: res.email
        });
        posthog.identify(res.user_id, {
          email: res.email,
          name: res.first_name
        });
        authenticated();
      } 
    } catch (err) {
      const errors = err?.response?.data;
      if (errors) {
        const firstField = Object.keys(errors)[0]; 
        const firstMessage = errors[firstField][0];
        setMessage(firstMessage);
        posthog.capture('signup_failure', {
          email: formData.email,
          error_message: firstMessage || 'unknown_error'
        });
      } else {
        setMessage('Signup failed. Try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto mt-20 p-6 bg-white border rounded shadow">
        <h2 className="text-2xl font-bold mb-6 text-center">Create Your Account</h2>

        <div className="flex gap-3 mb-3">
        <input
            name="first_name"
            type="text"
            placeholder="First Name"
            value={formData.first_name}
            onChange={handleChange}
            className="w-1/2 p-2 border rounded"
        />
        <input
            name="last_name"
            type="text"
            placeholder="Last Name"
            value={formData.last_name}
            onChange={handleChange}
            className="w-1/2 p-2 border rounded"
        />
        </div>

        <input
        name="email"
        type="email"
        placeholder="Email"
        value={formData.email}
        onChange={handleChange}
        className="w-full mb-3 p-2 border rounded"
        />

        <input
        name="password"
        type="password"
        placeholder="Password"
        value={formData.password}
        onChange={handleChange}
        className="w-full mb-3 p-2 border rounded"
        />
        {formData.password && formData.password.length < 8 && (
          <p className="text-sm text-red-600 mb-3 mt-1">Password must not be less than 8 characters</p>
          )}

        <input
        name="confirm_password"
        type="password"
        placeholder="Confirm Password"
        value={formData.confirm_password}
        onChange={handleChange}
        className="w-full mb-4 p-2 border rounded"
        />
        {formData.confirm_password && formData.confirm_password !== formData.password && (
          <p className="text-sm text-red-600 mb-3 mt-1">Passwords do not match</p>
          )}

        <button
        onClick={handleSubmit}
        disabled={loading}
        className="w-full bg-violet-900 text-white py-2 rounded hover:bg-violet-950 disabled:opacity-50"
        >
        {loading ? 'Signing Up...' : 'Sign Up'}
        </button>

        {message && <p className="mt-4 text-center text-sm text-red-700">{message}</p>}

        <div className="mt-6 text-center">
        <p className="text-sm text-gray-600">Already have an account?</p>
            <button
                onClick={() => {
                  updateShowLogin();
                  posthog.capture('navigate_to_login_from_signup', {
                    from: "signup_page"
                  });
                }}
                className="mt-2 text-violet-900 font-medium hover:underline"
            >
            Login
        </button>
        </div>
    </div>
  );
}
